import e from "../_virtual/_plugin-vue_export-helper.js";
import t from "./SchemaHeading.vue.script.js";
/* empty css                            */
//#region src/schema/SchemaHeading.vue
var n = /*#__PURE__*/ e(t, [["__scopeId", "data-v-39d4fd7f"]]);
//#endregion
export { n as default };

//# sourceMappingURL=SchemaHeading.vue.js.map